module.exports = __webpack_public_path__ + "img/room02_blackboard.0af659df.png";